module.exports = __webpack_public_path__ + "img/format.fd88dda9.svg";